var LR = document.querySelector('.le-lander') || document;

(function(){
  // reveal on scroll. The hidden state lives behind .reveal-js, which is only
  // added once this script is running, so a failed/blocked asset can never
  // leave the page stuck at opacity:0.
  var hasIO = 'IntersectionObserver' in window;
  if(hasIO && LR.classList){ LR.classList.add('reveal-js'); }
  var io;
  if(hasIO){
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
    },{threshold:.14});
    LR.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  }
  // fallback: reveal anything already in view on load, and reveal everything if the observer never fires
  function sweep(){
    var vh = window.innerHeight || 900;
    LR.querySelectorAll('.reveal:not(.in)').forEach(function(el){
      var r = el.getBoundingClientRect();
      if(r.top < vh*1.05 && r.bottom > 0){ el.classList.add('in'); }
    });
    var sc = document.getElementById('stickyCta');
    if(sc){ sc.classList.toggle('show', window.scrollY > 700); }
  }
  window.addEventListener('load', sweep);
  window.addEventListener('pageshow', sweep);   // bfcache restore
  setTimeout(sweep, 600);
  window.addEventListener('scroll', sweep, {passive:true});
  var sweepTimer = setInterval(function(){
    sweep();
    if(LR.querySelectorAll('.reveal:not(.in)').length === 0){ clearInterval(sweepTimer); }
  }, 800);
  setTimeout(function(){
    if(LR.querySelectorAll('.reveal.in').length === 0){
      LR.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
    }
  }, 1600);

  // drag-to-scroll rail
  var rail = document.getElementById('rail');
  if(rail){
    var down=false,startX=0,startL=0,moved=false;
    rail.addEventListener('pointerdown',function(e){down=true;moved=false;startX=e.clientX;startL=rail.scrollLeft;rail.classList.add('dragging');});
    window.addEventListener('pointermove',function(e){ if(!down)return; var dx=e.clientX-startX; if(Math.abs(dx)>6)moved=true; rail.scrollLeft=startL-dx; });
    window.addEventListener('pointerup',function(){down=false;rail.classList.remove('dragging');});
    rail.addEventListener('click',function(e){ if(moved){ e.preventDefault(); } },true);
  }

  // count-up stats
  var cio = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting) return;
      var el=e.target, to=parseFloat(el.dataset.to), dec=parseInt(el.dataset.dec||'0'), plus=el.dataset.plus;
      var t0=null;
      function step(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/1200,1); p=1-Math.pow(1-p,3);
        el.textContent = (to*p).toFixed(dec) + (p===1&&plus?'+':'');
        if(p<1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
      cio.unobserve(el);
    });
  },{threshold:.6});
  LR.querySelectorAll('.count').forEach(function(el){ cio.observe(el); });

  // payment calculator
  var range=document.getElementById('calcRange');
  function money(n){ return '$'+Math.round(n).toLocaleString('en-US'); }
  function upd(){
    var v=parseInt(range.value);
    document.getElementById('calcPrice').textContent=money(v);
    document.getElementById('out12').textContent=money(v/12);
    document.getElementById('out6').textContent=money(v/6);
    var o4=document.getElementById('out4'), l4=document.getElementById('out4lbl');
    if(v<=1000){ o4.textContent=money(v/4); o4.parentNode.innerHTML='4 &times; <em id="out4">'+money(v/4)+'</em>'; l4.textContent='Four interest-free payments*'; }
    else { document.getElementById('out4wrap').innerHTML='<em id="out4">n/a</em>'; l4.textContent='Pay-in-4 suits pieces under about $1,000'; }
  }
  if(range){ range.addEventListener('input',upd); upd(); }

  // sticky mobile CTA
  var cta=document.getElementById('stickyCta');
  window.addEventListener('scroll',function(){
    if(window.scrollY>700){ cta.classList.add('show'); } else { cta.classList.remove('show'); }
  },{passive:true});
})();

  // film facade: swap poster for the real player only on click, so YouTube
  // ships nothing on first paint
  LR.querySelectorAll('.film').forEach(function(btn){
    btn.addEventListener('click', function(){
      var id = btn.getAttribute('data-yt');
      if(!id || btn.dataset.loaded) return;
      btn.dataset.loaded = '1';
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
      f.title = btn.getAttribute('aria-label') || 'Natuzzi film';
      f.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture';
      f.allowFullscreen = true;
      var cap = btn.querySelector('.cap');
      btn.querySelector('img').remove();
      var p = btn.querySelector('.play'); if(p) p.remove();
      btn.insertBefore(f, cap);
    });
  });

  // sticky editorial: the pinned image follows whichever step is centred
  (function(){
    var steps = LR.querySelectorAll('.sticky-step');
    var figs  = LR.querySelectorAll('.sticky-media figure');
    if(!steps.length || !figs.length) return;
    var sio = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        var i = e.target.getAttribute('data-step');
        figs.forEach(function(f){ f.classList.toggle('on', f.getAttribute('data-step') === i); });
      });
    }, {rootMargin:'-45% 0px -45% 0px', threshold:0});
    steps.forEach(function(s){ sio.observe(s); });
  })();

  // leather swatches
  (function(){
    var note = document.getElementById('swNote');
    LR.querySelectorAll('.sw').forEach(function(b){
      b.addEventListener('click', function(){
        LR.querySelectorAll('.sw').forEach(function(o){ o.setAttribute('aria-pressed','false'); });
        b.setAttribute('aria-pressed','true');
        if(note) note.textContent = b.dataset.name + ' — ' + b.dataset.desc;
      });
    });
  })();

